import { ShapeType } from "@/enums/ShapeType";
import { Shape } from "@/abstract/Shape";
import { Floor } from "../Floor";
import { Wall } from "../Wall";
import { SurfaceType } from "@/enums/SurfaceType";

export class Triangle extends Shape {
    floor: Floor = new Floor(["a (Length 1) ", "b (Length 2) ", "c (Length 3) "]);
    walls: Wall[] = new Array<Wall>();
    constructor() {
        super()
        this.walls.push(new Wall());
    }
    selected: boolean = false;
    previewImageURL: string = require(`../../assets/preview-triangle.svg`);
    dialogImageURL: string = require(`../../assets/Triangle-1.svg`);
    dropdownImageURL: string = require(`../../assets/Triangle-2.svg`);
    name: string = "Triangle";
    shapeType: ShapeType = ShapeType.Square;
    noOfWalls: number = 3;
    getArea(): number {
        var a = Number(this.floor.dimensions[0].value);
        var b = Number(this.floor.dimensions[1].value);
        var c = Number(this.floor.dimensions[2].value);
        var cal = Number((a + b + c) * (-a + b + c) * (a - b + c) * (a + b - c));
        return Number((0.25 * Math.sqrt(cal)).toFixed(2));
    }

    getRunningFeet(): number {
        return Number(this.floor.dimensions[0].value) + Number(this.floor.dimensions[1].value) + Number(this.floor.dimensions[2].value);
    }
    setWallsLength() {
        this.walls[0].dimensions[1].value = this.floor.dimensions[0].value;
        this.walls[1].dimensions[1].value = this.floor.dimensions[1].value;
        this.walls[2].dimensions[1].value = this.floor.dimensions[2].value;
    }
}